import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "../src/styles/antd.css";
import "../src/styles/ckEditor.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import "./styles/font.css";

import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import localeData from "dayjs/plugin/localeData";
import timeZone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import "react-image-gallery/styles/css/image-gallery.css";
import { persistStore } from "redux-persist";
import "../src/styles/imageGallery.css";

import "./i18n";

import { initStorageOptimization } from "./utils/storageOptimizer";
import { PersistGateModern } from "./components/PersistGateModern";

if (window.location.hostname.startsWith("www.")) {
  const newUrl = window.location.href.replace("://www.", "://");
  window.location.replace(newUrl);
}

dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(timeZone);
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);

// Optimize storage before creating persistor
initStorageOptimization();

export const persistor = persistStore(store);

const container = document.getElementById("root") as HTMLElement;

// Enable React 18 concurrent features
const root = ReactDOM.createRoot(container, {
  // Enable progressive hydration for future SSR
  onRecoverableError: (error, errorInfo) => {
    // Log recoverable errors silently
  },
});

// Render with modern PersistGate using React 18 concurrent features
root.render(
  <Provider store={store}>
    <PersistGateModern persistor={persistor}>
      <App />
    </PersistGateModern>
  </Provider>,
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
